module.exports = __webpack_public_path__ + "static/img/dl_zhanghao.a0595765.png";